import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { StyledTitleSection } from "app/pages/sales-intelligence/modules/ai-agent/components/CollapsedBriefSection/styles";

export const StyledPDFBackground = styled.div`
    @media print {
        position: fixed;
        inset: 0;
        background: ${colorsPalettes.carbon[0]};
        z-index: 0;
    }
`;

export const StyledPDFContent = styled.div`
    @media print {
        position: relative;
        z-index: 1;

        * {
            background: transparent !important;
            box-shadow: none !important;
        }


        /* Lines-per-page hints */
        p,
        li,
        h1,
        h2,
        h3,
        h4 {
            orphans: 3;
            widows: 3;
        }

        /* Try not to split logical blocks across pages */
        li,
        blockquote,
        table {
            break-inside: avoid;
        }

        /* Don’t leave headings alone at the bottom of a page */
        h1,
        h2,
        h3 {
            break-after: avoid;
        }

        ${StyledTitleSection} {
            break-after: avoid;
        }
    }
`;
